import { ChartPoint, LineLayerSpecification } from '../chart-props';
import { VectorDrawFunction } from './type';

export const drawLineLayer: VectorDrawFunction<LineLayerSpecification> = (pass, features, layer, xAxis, yAxis) => {
    let previousPoint: [number, number] | undefined;

    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        if (feature.geometry.type === 'Line') {
            previousPoint = undefined;
            if (feature.geometry.coordinates.length > 1) {
                let p1: ChartPoint | undefined;
                for (const coordinate of feature.geometry.coordinates) {
                    const p2 = [xAxis.project(coordinate[0], pass.viewState), yAxis.project(coordinate[1], pass.viewState)] as [
                        number,
                        number
                    ];

                    if (p1) {
                        pass.drawer.drawLine(p1, p2, {
                            width: layer.paint.width,
                            color: layer.paint.color,
                            style: layer.paint.style
                        });
                    }
                    p1 = p2;
                }
            }
        } else if (feature.geometry.type === 'Point') {
            const p2 = [
                xAxis.project(feature.geometry.coordinates[0], pass.viewState),
                yAxis.project(feature.geometry.coordinates[1], pass.viewState)
            ] as [number, number];
            if (previousPoint) {
                pass.drawer.drawLine(previousPoint, p2, {
                    width: layer.paint.width,
                    color: layer.paint.color,
                    style: layer.paint.style
                });
            }
            previousPoint = p2;
        }
    }
};
